import { getMomentDate } from 'lib/utils/date';

export const MONTHS_OF_YEAR_LIST = [
  'datetime.january',
  'datetime.february',
  'datetime.march',
  'datetime.april',
  'datetime.may',
  'datetime.june',
  'datetime.july',
  'datetime.august',
  'datetime.september',
  'datetime.october',
  'datetime.november',
  'datetime.december',
];

export const DAYS_OF_WEEK_LIST = [
  'datetime.monday.short',
  'datetime.tuesday.short',
  'datetime.wednesday.short',
  'datetime.thursday.short',
  'datetime.friday.short',
  'datetime.saturday.short',
  'datetime.sunday.short',
];

export const DAYS_OF_WEEK_MAP = {
  1: 'common.sunday',
  2: 'common.monday',
  3: 'common.tuesday',
  4: 'common.wednesday',
  5: 'common.thursday',
  6: 'common.friday',
  7: 'common.saturday',
};

export const DATE_PICKER_PRESET_LIST = [
  {
    label: 'Сегодня',
    getValue: () => {
      return {
        from: getMomentDate().startOf('day'),
        to: getMomentDate().startOf('day'),
      };
    },
  },
  {
    label: 'Вчера',
    getValue: () => {
      return {
        from: getMomentDate().subtract(1, 'day').startOf('day'),
        to: getMomentDate().subtract(1, 'day').startOf('day'),
      };
    },
  },
  {
    label: 'На этой неделе',
    getValue: () => {
      return {
        from: getMomentDate().startOf('isoWeek'),
        to: getMomentDate(),
      };
    },
  },
  {
    label: 'На прошлой неделе',
    getValue: () => {
      return {
        from: getMomentDate().subtract(1, 'week').startOf('isoWeek'),
        to: getMomentDate().subtract(1, 'week').endOf('isoWeek'),
      };
    },
  },
  {
    label: 'Этот месяц',
    getValue: () => {
      return {
        from: getMomentDate().startOf('month'),
        to: getMomentDate(),
      };
    },
  },
  {
    label: 'Прошлый месяц',
    getValue: () => {
      return {
        from: getMomentDate().subtract(1, 'month').startOf('month'),
        to: getMomentDate().subtract(1, 'month').endOf('month').startOf('day'),
      };
    },
  },
  {
    label: 'Весь период',
    getValue: () => null,
  },
];
